import { useNavigate } from "react-router";
import { useTestState } from "../context/TestContext";
import { useForm } from "react-hook-form";
import { useEffect } from "react";

type FormValues = {
  endOfTestNotes: string;
};

const Feedback = ({
  isB2b2c,
  isB2b,
  rht,
}: {
  isB2b2c: boolean;
  isB2b: boolean;
  rht: boolean;
}) => {
  const navigate = useNavigate();
  const { state, dispatch } = useTestState();
  const { register, handleSubmit, reset } = useForm<FormValues>();

  useEffect(() => {
    if (!state.contactid) {
      return navigate('/demographics');
    }
  }, [navigate, state.contactid]);
  
  const onSubmit = ({ endOfTestNotes }: FormValues) => {
    dispatch({
      type: 'UPDATE_ENDOFTESTNOTES',
      payload: endOfTestNotes ?? '',
    });
    reset();
    navigate('/results');
  };

  return (
    <div className="demographics">
      <h1 className="top-title-text" style={{ fontSize: "24px" }}>
        Thank you for completing the Audicus Hearing Test!
      </h1>
      <form className="form-content" onSubmit={handleSubmit(onSubmit)}>
        <div>
          <p>You may use the space below to provide notes about the session (optional), then submit to view the results.</p>
          <textarea
            style={{ width: '100%' }}
            rows={6}
            placeholder="Type your notes here…"
            {...register('endOfTestNotes')}
          />
        </div>

        <input type="submit" className="link-button" value="Submit" />
      </form>
    </div>
  );
};

export default Feedback;